export const IFRAME_ONMESSAGE = 'IFRAME_ONMESSAGE'

// dispatch actions when iframe messages are received
export default (store, options) => {
  window.addEventListener('message', ({data}) => {

    if (!data) {
      return
    }
    const keys = Object.keys(data)
    // filter out events that don't contain a property on the whitelist
    if (options && options.propertyWhitelist && !options.propertyWhitelist.some(v => keys.indexOf(v) >= 0)) {
      return
    }

    store.dispatch({
      type: IFRAME_ONMESSAGE,
      data
    })
  }, false)
}



/** WEBPACK FOOTER **
 ** ./src/store/iframeOnMessage.js
 **/